module.exports = __webpack_public_path__ + "static/media/new_logo.8a90c60f.png";